import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SelectOption } from '@/features/editMode/types/selectOption';
import { initialGeographyState } from './constants';

const geographySlice = createSlice({
  name: 'geography',
  initialState: initialGeographyState,
  reducers: {
    updateCountriesList: (state, { payload }: PayloadAction<SelectOption[]>) => {
      state.countriesList = payload;
    },
    setCountriesListLoadingStatus: (state, { payload }: PayloadAction<boolean>) => {
      state.statuses.isCountriesListLoading = payload;
    },
    updateStatesList: (state, { payload }: PayloadAction<SelectOption[]>) => {
      state.statesList = payload;
    },
    setStatesListLoadingStatus: (state, { payload }: PayloadAction<boolean>) => {
      state.statuses.isStatesListLoading = payload;
    },
    getCountriesList: () => {},
    getStatesList: (_state, _action: PayloadAction<string | undefined>) => {},
    resetGeographyState: () => ({
      ...initialGeographyState,
    }),
  },
  selectors: {
    selectCountriesList: (state) => state.countriesList,
    selectStatesList: (state) => state.statesList,
    selectCountriesListIsLoading: (state) => state.statuses.isCountriesListLoading,
    selectStatesListIsLoading: (state) => state.statuses.isStatesListLoading,
  },
});

export const {
  getCountriesList,
  getStatesList,
  updateCountriesList,
  updateStatesList,
  setCountriesListLoadingStatus,
  setStatesListLoadingStatus,
  resetGeographyState,
} = geographySlice.actions;

export const { selectCountriesList, selectStatesList, selectCountriesListIsLoading, selectStatesListIsLoading } =
  geographySlice.selectors;

export const geographyReducer = geographySlice.reducer;
export const geographyReducerPath = geographySlice.reducerPath;
